import { Store } from 'pullstate';
import { FeatureData, PuzzleData } from './utils/types';
import { PuzzleNames } from './utils/types';

export type AppStoreType = {
  loadingUser: boolean;
  loadingContent: boolean;
  loadingUserError: boolean;
  loadingContentError: boolean;
  signedIn: boolean;
  signInDialog: {
    isOpen: boolean;
    redirectPathAfterLogin: string | null;
  };
  puzzleData: PuzzleData | null;
  featureData: FeatureData | null;
  userData: {
    settings: {
      hapticFeedbackEnabled: boolean;
      pathwordDefaultHints: number;
      pathword5x5DefaultHints: number;
    };
    stats: {
      [puzzleName in PuzzleNames]: {
        numPlayed: number;
        numSolved: number;
        currentStreak: number;
        bestTime: number | null;
        averageTime: number | null;
        under10?: number;
        under30?: number;
        under60?: number;
        under120?: number;
        under300?: number;
        under600?: number;
        under1200?: number;
        under2400?: number;
        under3600?: number;
      };
    };
  } | null;
};

export const AppStore = new Store<AppStoreType>({
  loadingUser: true,
  loadingContent: true,
  loadingUserError: false,
  loadingContentError: false,
  signedIn: false,
  signInDialog: {
    isOpen: false,
    redirectPathAfterLogin: null,
  },
  puzzleData: null,
  featureData: null,
  userData: null,
});